// Page title (with approved / sheet-inbox counts for admins) and the Reload button.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.

export default function PageHeader({ appTotal, busy, inboxCount, me, pending, refresh, refreshing, unmatched }) {
  return (
    <>
      <div className="page-head">
        <h1>Review queue
          {refreshing && (
            <span style={{ marginLeft: '0.75rem', fontSize: '0.55em', color: '#0369a1', fontWeight: 400, fontStyle: 'italic' }}>
              ↻ updating…
            </span>
          )}
          {me && me.isAdmin && (
            <span className="small"> — Approved: {appTotal.toLocaleString()} · Sheet inbox: {pending.counts.total.toLocaleString()} ({pending.counts.matched.toLocaleString()} matched · {pending.counts.unmatchedHistorical.toLocaleString()} unmatched · {pending.counts.pending.toLocaleString()} pending)</span>
          )}
        </h1>
        <div className="page-head-controls">
          {/* Refresh Google Sheet / Full re-sync / Sheet changes / Admin
              tools buttons hidden by Suresh's request 2026-07-09. Sync
              still runs on the schema-036 trigger + realtime path, and
              admins can reach the Sheet changes inbox by scrolling to
              the inbox card lower on the page, or use the Danger Zone
              anchor directly (#danger-zone). To restore the buttons,
              re-enable this block. */}
          {inboxCount > 0 && (
            <span className="small" style={{ color: '#b91c1c', fontWeight: 600 }}>
              &#128229; {inboxCount} sheet change{inboxCount === 1 ? '' : 's'} pending
            </span>
          )}
          <button className="refresh-btn" onClick={refresh}           disabled={busy}>Reload</button>
        </div>
      </div>
    </>
  );
}
